module.exports = __webpack_public_path__ + "img/sw-ps-sm.255bf660.webp";